import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environement';
import { PaiementEnfantDTO } from '../../../models/PaiementEnfantDTO';

@Injectable({
  providedIn: 'root'
})
export class PaieService {
  private baseUrl = environment.apiUrl + '/api/v1/paie';

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  private getAuthHeaders(): { [header: string]: string } {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('presence');
      return token ? { Authorization: `Bearer ${token}` } : {};
    }
    return {};
  }

  // LOGIC PARENT

  getPaiementsByParent(parentId: number): Observable<PaiementEnfantDTO[]> {
    return this.http.get<PaiementEnfantDTO[]>(`${this.baseUrl}/parent/${parentId}`, { headers: this.getAuthHeaders() });
  }

  getPaiementsEnfantByEtablissement(etablissementId: number): Observable<PaiementEnfantDTO[]> {
    return this.http.get<PaiementEnfantDTO[]>(`${this.baseUrl}/enfant/etablissement/${etablissementId}`, { headers: this.getAuthHeaders() });
  }

  effectuerPaiementEnfant(enfantId: number, mois: number, annee: number, montant: number, methode: string): Observable<PaiementEnfantDTO> {
    let params = new HttpParams()
      .set('enfantId', enfantId.toString())
      .set('mois', mois.toString())
      .set('annee', annee.toString())
      .set('montant', montant.toString())
      .set('methode', methode);

    return this.http.post<PaiementEnfantDTO>(`${this.baseUrl}/enfant/payer`, null, { params, headers: this.getAuthHeaders() });
  }

  processOnlinePayment(paiementId: number, stripeToken: string): Observable<PaiementEnfantDTO> {
    const paymentUrl = environment.apiUrl + '/api/v1/payments/online/' + paiementId;
    let params = new HttpParams().set('stripeToken', stripeToken);
    return this.http.post<PaiementEnfantDTO>(paymentUrl, null, { params, headers: this.getAuthHeaders() });
  }

  generateTestBilling(): Observable<any> {
    const generateUrl = environment.apiUrl + '/api/v1/payments/generate-test';
    return this.http.post(generateUrl, null, { responseType: 'text', headers: this.getAuthHeaders() });
  }

  relancerPaiement(paiementId: number): Observable<any> {
    const url = `${this.baseUrl}/${paiementId}/relancer`;
    return this.http.post(url, null, { headers: this.getAuthHeaders() });
  }
}
